export default {
    csManagement: {
        page: {
            title: 'CS Management',
            description: 'Manage tenant quotas, project limits and token consumption',
        },
        quota: {
            searchPlaceholder: 'Search tenant ID',
            typePlaceholder: 'Quota type',
            search: 'Search',
            create: 'Add Quota',
            tenantId: 'Tenant ID',
            quotaType: 'Quota Type',
            typeDocument: 'Project Total',
            typeToken: 'Token',
            quotaLimit: 'Limit',
            quotaUsed: 'Used',
            contractPeriod: 'Contract Period',
            contractStart: 'Start Date',
            contractEnd: 'End Date',
            status: 'Status',
            statusActive: 'Active',
            statusExpired: 'Expired',
            remark: 'Remark',
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            createTitle: 'Add Quota',
            editTitle: 'Edit Quota',
            cancel: 'Cancel',
            confirm: 'Confirm',
            saving: 'Saving...',
            featureConfig: 'Feature Config',
            featureConfigTitle: 'Feature Permission Config',
            featureQuotaSectionTitle: 'Project Limits by Type',
            featureQuotaSectionDesc: 'Set how many projects of each type can be created during the contract period. -1 means unlimited, 0 disables the feature.',
            featureDisclosure: 'Disclosure',
            featureDisclosureLimit: 'Disclosure Project Limit',
            featureDisclosureDesc: 'Patent disclosure projects',
            featurePatentDraft: 'Patent Application',
            featurePatentDraftLimit: 'Patent Application Project Limit',
            featurePatentDraftDesc: 'Patent application projects',
            featureProsecution: 'OAR Response',
            featureProsecutionLimit: 'OAR Response Project Limit',
            featureProsecutionDesc: 'Office action response projects',
            featureLimitHint: '* -1 means unlimited, 0 disables the feature',
            featureLimitExceeded: 'Project type quota total {total} cannot exceed company project limit {limit}',
            userAllocationExceeded: 'Total project type allocation ({total}) exceeds the company project limit ({limit}). Please adjust it.',
            featureUsed: 'Used',
            featureRemaining: 'Remaining',
            featureReachedLimit: 'Limit reached',
            featureLimitBelowUsedWarning: 'Limit is below the number of projects used',
            featureDisabled: 'Disabled',
            userQuotaTitle: 'User Project Quota Details',
            userQuotaHint: 'Company project limit: {limit}',
            userEmail: 'User Email',
            unlimited: 'Unlimited',
            addUser: 'Add User',
            addUserPlaceholder: 'Enter user email',
            reset: 'Clear',
            deleteUserQuotaConfirmTitle: 'Delete this user quota configuration?',
            deleteUserQuotaConfirmDesc: 'After deletion, this user will no longer appear in user project quota details and personal project type limits will return to unconfigured.',
            tenantName: 'Company Name',
            configuredMembers: 'Configured Members',
            noConfiguredMembers: 'No configured members for this company',
            tenantInfoNotFound: 'Company not found',
            tenantInfoFailed: 'Failed to fetch, please retry',
            featureList: 'Features',
            featureAll: 'All',
        },
    },
};
